// src/i18n/es/channelsAnalytics.ts
// «Canales» (mockup 06) — route /channels, Dirección. Channel *labels* stay in
// `resources.channels` (the shared registry dict); this file only carries the
// page's own copy (titles, column headers, help).
export const channelsAnalytics = {
  name: 'Canales |||| Canales',
  subtitle: 'Cómo se reparten las llegadas entre canales y dónde se detienen',

  table: {
    title: 'Por canal',
    dispenserKeyOnly: 'Dispensador (solo llave)',
    description:
      'Cada recorrido cuenta en el canal donde terminó el check-in; si aún no lo ha terminado, en el último canal al que pasó; «Dispensador (solo llave)» son los recorridos que terminaron recogiendo la llave en el dispensador sin check-in. Los cambios de canal se muestran aparte. La sesión es el propio pre-check-in en Online y, en los demás canales, del inicio del check-in a su finalización (sin la entrega de la llave); la mediana y los cortes de 2 y 5 minutos miden esa misma sesión. Con menos de 20 casos no se muestra la cifra.',
    columns: {
      channel: 'Canal',
      journeys: 'Recorridos',
      completionRate: '% completadas',
      medianTotalMinutes: 'Duración mediana de la sesión',
      under2MinPct: '< 2 min',
      under5MinPct: '< 5 min',
      retried: 'Volvieron a intentarlo',
    },
  },

  keys: {
    title: 'Entrega de llaves',
    description:
      'Recorridos del periodo con llave entregada en el kiosco o en el dispensador, por tipo de llave («Sin tipo» cuando el equipo no lo indica). «Fallidas»: recorridos con un error de entrega allí y sin llave entregada. El dispensador solo entrega tarjetas.',
    columns: {
      where: 'Origen',
      delivered: 'Entregadas',
      card: 'Tarjeta',
      digital: 'Digital',
      unknown: 'Sin tipo',
      failed: 'Fallidas',
    },
    whereKiosk: 'Kiosco',
    whereDispenser: 'Dispensador',
  },

  stops: {
    title: 'Dónde se detienen',
    description:
      'Cada sección cuenta en el canal donde se mostró. «Llegaron»: recorridos del periodo que entraron en la sección; «Se detuvieron»: los que la abandonaron allí. Debajo, el tiempo mediano en la sección (de la entrada a la salida). El porcentaje necesita al menos 20 recorridos y el tiempo, al menos 20 visitas con entrada y salida.',
    insufficient: 'muestra insuficiente',
    median: 'mediana %{time}',
    medianInsufficient: 'mediana: muestra insuficiente (n = %{count})',
    columns: {
      section: 'Sección',
      reached: 'Llegaron',
      stopped: 'Se detuvieron',
      pct: '%',
      medianSeconds: 'Tiempo mediano',
    },
  },

  transitions: {
    title: 'Cambios de canal',
    fromPartial: '%{channel} · a medias',
    columns: {
      from: 'Desde',
      to: 'Hasta',
      journeys: 'Reservas',
      complete: 'Completadas',
    },
  },

  chart: {
    title: 'Reparto por canal',
  },

  filters: {
    channel: 'Canal',
  },

  axis: {
    arrival: 'Fecha de llegada',
    activity: 'Fecha de actividad',
  },

  help: {
    title: 'Canales',
    description: 'Cómo llegan los huéspedes a cada canal, cuánto tardan y en qué sección se detienen con más frecuencia.',
    features: {
      table: 'La tabla por canal compara volumen, duración y reintentos. «Volvieron a intentarlo» solo se mide en Online: huéspedes que reabrieron el pre-check-in tras un intento que se quedó a medias, antes de terminarlo; «—» en los demás canales.',
      stops: 'Dónde se detienen muestra en qué sección abandona cada canal.',
      sample: 'Los porcentajes, medianas y cortes de tiempo necesitan al menos 20 casos; por debajo verá «Muestra insuficiente» con el número de casos.',
    },
    tips: {
      channel: 'Use el filtro «Canal» para ver solo los canales que le interesan, por ejemplo Pre-check-in online.',
      axis: 'El eje por defecto es la fecha de llegada; con fecha de actividad, cada recorrido cuenta el día (del hotel) en que empezó. Todos los bloques de la pantalla usan los mismos recorridos.',
    },
  },
};

export default channelsAnalytics;
